import type { NavProps} from 'src/components/navbar';

import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import Box from '@mui/material/Box';
import useTheme from '@mui/system/useTheme';

import { getFilteredNavData } from 'src/utils/utils';

import { useAuthContext } from 'src/auth';
import NavBarIcon from 'src/pages/components/NavBarIcon';

import { NavSectionMini } from 'src/components/navbar';

const navData: NavProps['data'] = [
  {
    subheader: '',
    items: [
      { id: 'sales', title: 'Sales', path: '/sales', icon: NavBarIcon('ic_external') },
      {
        id: 'compliance',
        title: 'Compliance',
        path: '/compliance',
        icon: NavBarIcon('ic_align_left'),
      },
      { id: 'servicing', title: 'Servicing', path: '/servicing', icon: NavBarIcon('ic_dashboard') },
    ],
  },
];

const MiniSideNav = () => {
  const theme = useTheme();
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [filteredNavData, setFilteredNavData] = useState<NavProps['data']>([]);

  /**
   * Filters the navigation data based on the user's roles and sets the filtered data.
   * This effect runs whenever the user object changes.
   */
  useEffect(() => {
    const userRoles = user?.roles ?? [];
    if (userRoles.length > 0) {
      setFilteredNavData(getFilteredNavData(navData, userRoles));
    }
  }, [user]);

  /**
   * Redirects the user to the first item in the Nav list path if no pathname or '/'.
   * This effect runs whenever the pathname or filteredNavData changes.
   */
  useEffect(() => {
    if (
      (!location.pathname || location.pathname === '/') &&
      filteredNavData.length > 0 &&
      filteredNavData[0].items.length > 0
    ) {
      navigate(filteredNavData[0].items[0].path);
    }
  }, [location.pathname, filteredNavData, navigate]);

  return (
    <Box
      component="nav"
      sx={{
        minHeight: '100vh',
        backgroundColor: theme.palette.common.white,
        borderRight: `1px dashed ${theme.palette.divider}`,
        minWidth: 86,
        top: 0,
        position: 'sticky',
        pt: 2,
      }}
    >
      <NavSectionMini data={filteredNavData} />
    </Box>
  );
};
export default MiniSideNav;
